import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  toasts: any[] = [];

  show(header: string, text: string, options: any = {}) {
    this.toasts.push({ header, text, ...options });
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
